import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-get-date-time',
  templateUrl: './get-date-time.component.html',
  styleUrls: ['./get-date-time.component.scss']
})
export class GetDateTimeComponent {
  @Input() dateTime!: Date;
  
  formatDateTime(date: Date): string {
    const today = new Date();
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
  
    if (date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()) {
      return new DatePipe('en-US').transform(date, 'h:mm a');
    } else if (date.getDate() === yesterday.getDate() &&
               date.getMonth() === yesterday.getMonth() &&
               date.getFullYear() === yesterday.getFullYear()) {
      return `Yesterday, ${new DatePipe('en-US').transform(date, 'h:mm a')}`;
    } else if (sevenDaysAgo <= date && date < today) {
      return new DatePipe('en-US').transform(date, 'EEE, h:mm a');
    } else {
      return new DatePipe('en-US').transform(date, 'd-MMM h:mm a');
    }
  }
}
